<template>
<div>
    <div class="site-mobile-shade"></div>
	<header>
		<div class="layui-container">
			<div class="logo">
				<a href="./"><img src="../../assets/images/logo.png" alt=""></a>
			</div>
			<div class="header-mobile" @click="showMenu">
				<div class="site-tree-mobile">
					<span class="icon-reorder"></span>
					<span class="icon-reorder"></span>
					<span class="icon-reorder"></span>
				</div>
			</div>
			<ul class="layui-nav" lay-filter="">
				<li class="layui-nav-item"><a href="https://gbc.cncima.com/2026/#page1">赛事介绍</a></li>
				<li class="layui-nav-item"><a href="https://gbc.cncima.com/2026/#page2">赛制</a></li>
				<li class="layui-nav-item"><a href="https://gbc.cncima.com/2026/#page3">大赛日程</a></li>
				<li class="layui-nav-item"><a href="https://gbc.cncima.com/2026/#page4">往届回顾</a></li>
				<li class="layui-nav-item"><a href="https://gbc.cncima.com/2026/#page5">往届选手分享</a></li>
				<!-- <li class="layui-nav-item"><a href="https://gbc.cncima.com/2026/#page6">关于我们</a></li> -->
			</ul>
			<div class="button-box login-box" v-if="user_name===''">
				<router-link to="login" target="_blank" class="layui-btn login">登录</router-link>
				<router-link to="/login" target="_blank" class="layui-btn register">注册</router-link>
			</div>

			<div class="button-box out-box" v-else>
        <!-- <a @click="$router.push('form')" class="layui-btn qiehuan">切换赛事</a> -->
        <!-- <el-dropdown>
            <span class="el-dropdown-link">
               <span class="user-name">{{this.user_name}}</span><i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>
                    <a @click="userout">退出</a>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
      </el-dropdown> -->
				<a class="layui-btn register" @click="userout">退出</a>
        
			</div>
			<div class="clearB"></div>
		</div>
	</header>
</div>
</template>

<script>
import "../../assets/css/header_new.css"
import $ from "jquery"
import {
    apiGetUserInfo,
    apiLogut
}from '../../plugins/apis'
export default {
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data () {
    return {
		user_name:''
	}
  },
  async mounted () {
    if(window.localStorage.cima_app_name){
      this.user_name = window.localStorage.cima_app_name
    }
    await this.getUserInfo()
		show()
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {  
    showMenu(){
      if($("body").hasClass("site-mobile")){
        $("body").removeClass("site-mobile")
      }else{
        $("body").addClass("site-mobile")
      }
    },
    async getUserInfo(){
      let res = await apiGetUserInfo()
      if(res.code === 200){
        this.user_name = res.data.real_name
        window.localStorage.setItem('cima_app_name',this.user_name)
        // $(".login-box").css("display","none")
        // $(".out-box").css("display","block")
      }
      },
    async userout(){
      let redirect_uri = window.location.origin+'/report/login';
      let e = await apiLogut({
        redirect_uri
      })
      window.localStorage.clear();

      if(e.code === 200){
        window.location.href=e.data.url
      }else{
        window.location.href=redirect_uri
      }
      
    }
    },
}
function show(){
       
        $('.layui-nav').delegate('li', 'click', function () {
         $(".layui-nav-item").removeClass("layui-this")
        $(this).addClass("layui-this")
        })
   
}

</script> 

<style scoped>
.out-box{
	color: #fff;
}
@media screen and (max-width:991px) {
	/* .layui-nav{
		background:-webkit-linear-gradient(left, rgb(103, 45, 137), rgba(255, 247, 234, 0)) rgb(169, 63, 107)!important
	}	 */
}
.el-dropdown-link {
    cursor: pointer;
    color: #fff;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
</style>
